import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { connect } from 'react-redux';
import { getBiens, clearBiens, searchBiens } from '../../../flux/actions/bienActions';
import { IVBienContainer, IVBienReduxProps, ITableClientLine, ITarget, IBien } from '../../../types/interfaces';
import VBienCard from './VBienCard';
import VBienTable from './VBienTable';

import Loading from '../../Loading';

const VBienContainer = ({
  project,
  isAssociation,
  getBiens,
  clearBiens,
  bien,
  selectedBien,
  setSelectedBien,
  association,
  setAssociation,
  remiseValue,
  setRemiseValue,
  remiseTotalValue,
  setRemiseTotalValue,
  prixAafficherValue,
  setPrixAafficherValue,
  prixAafficherTotalValue,
  setPrixAafficherTotalValue,
  auth
}: IVBienContainer) => {
  const { biens, loading } = bien;
  const [tableData, setTableData] = useState(biens);
  // const [bienLines, setBienLines] = useState<IBien[]>([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [trancheValue, setTranche] = useState('');
  const [typeValue, setType] = useState('');
  const [immeubleValue, setImmeuble] = useState('');
  const [numValue, setNum] = useState('');
  const [etageValue, setEtage] = useState('');

  const trancheChangeHandler = (e: ITarget) => setTranche(e.target.value);
  const typeChangeHandler = (e: ITarget) => setType(e.target.value);
  const immeubleChangeHandler = (e: ITarget) => setImmeuble(e.target.value);
  const numChangeHandler = (e: ITarget) => setNum(e.target.value);
  const etageChangeHandler = (e: ITarget) => setEtage(e.target.value);

  useEffect(() => {
    clearBiens();
    if(project !== null && project !== undefined && project.LIBELE)
      getBiens(project.id, isAssociation ? 1 : 0);
  }, [getBiens, project, isAssociation]);

  useEffect(() => {
    return () => {
      clearBiens();
    }
  }, []);

  useEffect(() => {
    setTableData(biens);
  }, [biens]);

  // useEffect(() => {
  //   setBienLines([]);
  //   if(trancheValue !== "" || typeValue !== "" || immeubleValue !== "" || numValue !== "" || etageValue !== ""){
  //     setTableLoading(true);
  //     searchBiens(trancheValue, typeValue, immeubleValue, numValue, etageValue).then(e => {
  //       setTimeout(() => {
  //       setBienLines(e);
  //       setTableLoading(false);
  //       },200)
  //     }).catch(err => {
  //       console.error("err", err)
  //       setBienLines([]);
  //       setTableLoading(false);
  //     });
  //   }
  // }, [trancheValue, typeValue, immeubleValue, numValue, etageValue])

  // const promiseOptions = inputValue =>
  //   new Promise(resolve => {
  //     searchClients(inputValue).then(e => 
  //       resolve(e.map(t => ({label: `${t.NOM} ${t.PRENOM}`, value: t})))
  //     ).catch(err => resolve([]));
  //   });

  return (
    <div>
      {selectedBien ? <VBienCard selectedBien={selectedBien} setSelectedBien={setSelectedBien} isAssociation={isAssociation} association={association} setAssociation={setAssociation} remiseValue={remiseValue} setRemiseValue={setRemiseValue} remiseTotalValue={remiseTotalValue} setRemiseTotalValue={setRemiseTotalValue} prixAafficherValue={prixAafficherValue} setPrixAafficherValue={setPrixAafficherValue} prixAafficherTotalValue={prixAafficherTotalValue} setPrixAafficherTotalValue={setPrixAafficherTotalValue} /> : <div className="fadeAnimation">
      <Container className="searchBienDiv" style={{display: "none"}}>
        <Row className="justify-content-around mb-3">
          <Col xs="12" md="2">
            <FormGroup>
              <Label for="tranche">Tranche</Label>
              <Input id="tranche" value={trancheValue} onChange={trancheChangeHandler} />
            </FormGroup>
          </Col>
          <Col xs="12" md="2">
            <FormGroup>
              <Label for="type">Type</Label>
              <Input id="type" value={typeValue} onChange={typeChangeHandler} />
            </FormGroup>
          </Col>
          <Col xs="12" md="2">
            <FormGroup>
              <Label for="immeuble">Immeuble</Label>
              <Input id="immeuble" value={immeubleValue} onChange={immeubleChangeHandler} />
            </FormGroup>
          </Col>
          <Col xs="12" md="2">
            <FormGroup>
              <Label for="num">Num</Label>
              <Input id="num" value={numValue} onChange={numChangeHandler} />
            </FormGroup>
          </Col>
          <Col xs="12" md="2">
            <FormGroup>
              <Label for="etage">Étage</Label>
              <Input id="etage" value={etageValue} onChange={etageChangeHandler} />
            </FormGroup>
          </Col>
        </Row>
      </Container>
      {loading ? <Loading topSpace /> : <VBienTable linesData={tableData} setSelectedBien={setSelectedBien} isAssociation={isAssociation} />}
      </div>}
    </div>
  );
};

const mapStateToProps = (state: IVBienReduxProps) => ({
  bien: state.bien,
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { getBiens, clearBiens })(VBienContainer);
